export const metadata = {
  title: "Venue Spotlight: Domo Polideportivo 🔍",
  date: "2025-05-01",
  excerpt: "A deeper look at the venue hosting the CONCACAF Women's Futsal Championship in Guatemala",
  slug: "venue-spotlight-domo-polideportivo",
content: `

Today we are taking a closer look at the host venue for the CONCACAF Women's Futsal Championship. 

The Domo Polideportivo, in Guatemala City, Guatemala, will host all competition matches for the inaugural CONCACAF Women's Futsal Championship.

The tournament will see two groups of 4 battle it out against each other before the top two teams from each group will advance to the Semi Finals. 

Only the two teams that reach the final will secure their spot at the Women's Futsal World Cup which (due to take place in the Philippines in November and December of 2025).

The first thing you will notice is the circular arrangement that is visible from the exterior and results with an interior ceiling somewhat reminiscent of a something you might find in a sci-fi movie.

While I cannot comment on the atmosphere generated one can only imagine that the circular seating results in a very intimate atmosphere that gives specators a great vue regardless of position.

The venue was built specifically to host the 2000 Futsal World Cup and has gone on to host a number of futsal events since. (2000 FIFA World Futsal Championship, 2008 Concacaf Futsal Championship
, 2012 Concacaf Futsal Championship and 2020 Concacaf Futsal Championship)

The capacity of this venue appears to be somewhat contested with some sources claiming there is capacity for 10500 whereas other's claim there is enough for 7500.

The venue is owned and operated by the Autonomous Sports Confederation of Guatemala and has also hosted musical performances, in addition to cultural and political activities for which the CDAG leases the site. According to the CDAG the Dome is a beautiful place, but the high cost of its operation has affected its role in sport, because most of the country's sports federations and associations cannot afford the cost of its use. In 2003 60 percent of the activities held at the Dome were not related to sport.
`,
images: [
  {
    src: "/images/blog/domo.png",
    alt: "Court view",
  }
],
};
  